<template>
  <div class="video_box_s">
    <div class="video_box">
      <!-- <div class="audiotitlex">
        <div class="img_box">
          <img class="img_box" src="@/assets/icon/tupi.png" />
        </div>
        <div class="fileName_box">
          {{ fileName }}
        </div>
      </div> -->
      <div class="video_con">
        <iframe :src="src" frameborder="0" class="iframe" id="iframe"></iframe>
        <!-- <iframe src="http://192.168.1.232:5173/#/xml-preview-loose-leaf" frameborder="0" class="iframe" id="iframe"></iframe> -->
      </div>
    </div>
  </div>
</template>
<script>
import {
  selectTimeParameter, //获取调用阅读时长接口频率
  updateOcDownloadReading, //更新用户阅读时长
  selectFileLinkAndReadingLocation, //查看阅读文件地址和文件进度
} from "@/api/special/special";
import { checkIsBuy, isHavingPermissions } from "@/api/bookstore/bookstore";
import { createPreviewSrc } from "@/api/looseleaf/looseleaf";
import { looseleafGetToken } from "@/api/index/index";
import { setBrowserToken } from "@/utils/auth.js"
export default {
  data() {
    return {
      src: "",
      fileName: "",
      goodsId: this.$route.query.goodsId, //需要传递的参数
      filesId: "", //需要传递的参数(资源文件id)
      bookdetail: {}, //基本信息
      sourceList: [], //文件信息
      readdefault: 0, //默认阅读第一个
      item: undefined,
      index: undefined,
      srcList: [],
      loading: false,
      setInterval2: undefined,
      TimeParameter: 10, //更新频次-单位分钟
    };
  },
  created() { },
  destroyed() {
    this.closeTime();
  },
  methods: {
    looseleaf(item, index, catalogId) {
      let info = {
        userId: this.userId || '1',
        goodsId: this.$route.query.goodsId,
        platform: 'web',
        timestamp: '1',
        isShowAi: item.isShowAi,
        isTrial: item.isTrial,
        browserFinger: this.$route.query.browserFinger || ""
      }
      setBrowserToken(JSON.stringify(info))
      this.src =
        `./#/textBookReader?pageType=${this.$route.query.pageType ? this.$route.query.pageType : "pc"
        }&businessType=textBook&textBookId=` +
        item.filesId +
        "&bookName=" +
        item.bookName +
        "&catalogId=" +
        catalogId + "&goodsId=" + this.$route.query.goodsId + "&sysId=" + this.$route.query.sysId + "&userFlag=" + this.$route.query.userFlag + "&source=" + this.$route.query.source;
      // looseleafGetToken().then((res) => {
      //   let data = {
      //     token: res.data,
      //     pageType: "pc",
      //     businessType: item.type,
      //     looseLeafId: "",
      //     textBookId: "",
      //     isTrial: this.$route.query.isTrial || false,
      //   };
      //   if (item.type == "looseLeaf") {
      //     data.looseLeafId = item.filesId;
      //   } else {
      //     data.textBookId = item.filesId;
      //   }
      //   createPreviewSrc(data).then((res) => {
      //     if (res.code == 200) {
      //       this.src = res.data;
      //     }
      //   });
      // });
      window.location.replace(this.src);
      // window.location.href = this.src;
    },

    selectTimeParameter() {
      //获取更新 时长和进度 的频次
      selectTimeParameter().then((res) => {
        this.TimeParameter = res.data;
        this.setInterval2 = setInterval(() => {
          this.updateOcDownloadReading(); //更新阅读时长
        }, this.TimeParameter * 60000);
      });
    },
    closeTime() {
      clearInterval(this.setInterval2);
      this.setInterval2 = null;
    },
    updateOcDownloadReading() {
      //更新用户阅读时长接口
      updateOcDownloadReading({
        goodsFileId: this.filesId,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => { });
    },
    tabbook(item) {
      this.fileName = item.sourceName;
      this.filesId = item.filesId;
      this.loading = this.$loading({
        lock: true,
      });
      isHavingPermissions({
        goodsFileId: item.filesId,
        fileType: item.fileType,
        goodsId: this.$route.query.goodsId,
        relevanceId: this.$route.query.relevanceId,
        resource: this.$route.query.resource,
        resourceType: this.$route.query.resourceType,
        teachInstId: this.$route.query.teachInstId,
      }).then((res) => {
        this.loading.close();
        let data = res.data;
        if (data) {
          this.buys(item, data);
        }
      });
    },
    buys(item, data) {
      //判断是否购买该商品
      this.payType = this.$route.query.payType
        ? this.$route.query.payType
        : "goods";
      checkIsBuy({
        relevanceId: this.goodsId,
        type: this.payType,
      }).then((res) => {
        if (data.hasPermission) {
          //有权限
          this.looseleaf(item);
          this.selectTimeParameter(); //获取更新进度和时长的频次   循环调用更新时长和更新进度方法
        } else if (res.data == "1" && item.sourceStatus == "2") {
          this.Trial = true; //试读
          this.looseleaf(item);
        } else {
          //无权限
          this.checkIsBuys();
        }
      });
    },
    checkIsBuys() {
      //无权限走购买流程
      this.$alert("该文件需要购买后才能阅读，是否确认购买", "购买", {
        confirmButtonText: "立即购买",
        callback: (action) => {
          if (action === "cancel") {
            return;
          }
          let userId = this.$store.getters.userId;
          if (!userId) {
            this.$store.commit("SET_REDIRECTPARAMS", {
              goodsId: this.$route.query.goodsId,
              relevanceId: this.$route.query.relevanceId,
              resource: this.$route.query.resource,
              resourceType: this.$route.query.resourceType,
            });
            this.$router.push({
              path: "/login",
              query: {
                redirectPath: "/onlineReading",
              },
            });
          } else {
            //判断是否购买该商品
            this.payType = this.$route.query.payType
              ? this.$route.query.payType
              : "goods";
            checkIsBuy({
              relevanceId: this.goodsId,
              type: this.payType,
            }).then((res) => {
              console.log("是否已购买响应", res);
              if (res.data === "2") {
                this.$message.error("数据异常");
                return;
              }
              if (res.data === "1") {
                this.$router.push({
                  path: "/submitOrder/index",
                  query: {
                    id: this.$route.query.goodsId,
                    from: "bookstore",
                  },
                });
              } else {
                this.$message("该商品已购买无需重复购买");
              }
            });
          }
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.video_box_s {
  overflow: hidden;
}

.video_box {
  width: 100%;
  min-height: 95vh;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
  background: #fffefd;
}

.video_boxt {
  width: 100%;
  float: left;
  font-size: 14px;
  padding: 0 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 41px;
  margin-bottom: 30px;
  height: 41px;
  border-bottom: 1px solid #f2f2f2;
}

.video_con {
  // width: 1320px;
  margin: 0 auto;
  // margin-bottom: 30px;
  overflow: hidden;
  // min-height: 90vh;
  // height: calc(100vh - 20px);
  height: 100vh;
  position: relative;
}

.img_box {
  width: 20px;
  height: 20px;
  background: #666666;
}

.audiotitlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 15px;
  border-bottom: 1px solid #f2f2f2;
  padding: 5px;
}

.fileName_box {
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}

.iframe {
  width: 100%;
  height: 100%;
  min-height: 90vh;
}
</style>
